module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0036.jpg?v=16c7ef12";